var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMissedImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.93994 18.24H13.0536",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93994 12.4272H16.8",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93994 15.3337H16.8",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93994 5.58569H10.87",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93994 9.521H16.8",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6536 18.4649L16.9514 22.1672",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6536 22.1672L16.9514 18.4649",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3113_683",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H25V25H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3113_683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0346 3.08691H7.70544C7.305 3.08691 6.98035 2.7623 6.98035 2.36187V1.09624C6.98035 0.69585 7.305 0.37124 7.70544 0.37124H14.0346C14.435 0.37124 14.7596 0.69585 14.7596 1.09624V2.36187C14.7596 2.7623 14.435 3.08691 14.0346 3.08691Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1353 20.2813C23.1353 22.6796 21.1911 24.6238 18.7929 24.6238C16.3946 24.6238 14.4505 22.6796 14.4505 20.2813C14.4505 17.8832 16.3946 15.939 18.7929 15.939C21.1911 15.939 23.1353 17.8832 23.1353 20.2813Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27404 1.72915H3.08429C2.41075 1.72915 1.86481 2.27515 1.86481 2.94868V23.4042C1.86481 24.0777 2.41075 24.6238 3.08429 24.6238H15.1367",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8752 14.3711V2.94868C19.8752 2.27515 19.3292 1.7292 18.6557 1.7292H16.466",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissedImg);
export default __webpack_public_path__ + "static/media/missedImg.32d0ecae62fdd62b3d16e351cb3b7147.svg";
export { ForwardRef as ReactComponent };